export const CONSTANTS = {
       CONTACT_PREFIX: "c_",
       PATIENT_PREFIX: "p_",
}

// http://localhost:4200/?uid=ajaygajra&apiKey=606028d3c3ecff1b2014886376054ada6621ef97&appId=9992e0c46c915d&region=us